import styled from 'styled-components/macro';


const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 60px;
`;

export default InputContainer;